(function () {
  var MAP_KEY = 'hdt_wishlist_variant_choice_v1';
  var pending = {}; // pid -> vid (last clicked)

  function readMap() {
    try {
      var raw = localStorage.getItem(MAP_KEY);
      var obj = raw ? JSON.parse(raw) : {};
      return obj && typeof obj === 'object' ? obj : {};
    } catch (e) {
      return {};
    }
  }

  function writeMap(map) {
    try {
      localStorage.setItem(MAP_KEY, JSON.stringify(map || {}));
    } catch (e) {}
  }

  function getPid(el) {
    if (!el) return '';
    // Ecomus sometimes uses id="PRODUCT_ID" instead of data-id
    return String(el.getAttribute('data-id') || el.id || '');
  }

  function getVid(el) {
    if (!el) return '';
    return String(el.getAttribute('data-variant-id') || '');
  }

  function isThemeActive(el) {
    if (!el) return false;
    var aria = (el.getAttribute('aria-pressed') || '').toLowerCase() === 'true';
    var cls = el.classList;
    var byClass =
      cls.contains('is-active') ||
      cls.contains('active') ||
      cls.contains('is-added') ||
      cls.contains('added');

    // Some themes toggle on SVG too
    var svg = el.querySelector('.hdt-svg-wis');
    var svgActive = svg ? (svg.classList.contains('is-active') || svg.classList.contains('active') || svg.classList.contains('is-added')) : false;

    return aria || byClass || svgActive;
  }

  function setUI(el, active) {
    if (!el) return;

    // Force-reset any product-based active state
    el.classList.remove('is-active', 'active', 'is-added', 'added');
    el.removeAttribute('data-active');
    el.setAttribute('aria-pressed', 'false');

    var svg = el.querySelector('.hdt-svg-wis');
    if (svg) svg.classList.remove('is-active', 'active', 'is-added', 'added');

    if (active) {
      // Apply a consistent active hook for your CSS
      el.classList.add('is-active');
      el.setAttribute('data-active', 'true');
      el.setAttribute('aria-pressed', 'true');
      if (svg) svg.classList.add('is-active');
    }
  }

  function findWishlistEl(e) {
    var path = (typeof e.composedPath === 'function') ? e.composedPath() : null;
    if (path && path.length) {
      for (var i = 0; i < path.length; i++) {
        var n = path[i];
        if (n && n.tagName && String(n.tagName).toLowerCase() === 'hdt-wishlist') return n;
      }
    }
    return e.target && e.target.closest ? e.target.closest('hdt-wishlist') : null;
  }

  function syncPid(pid) {
    if (!pid) return;

    var buttons = Array.prototype.slice.call(
      document.querySelectorAll('hdt-wishlist[data-id="' + pid + '"], hdt-wishlist#' + CSS.escape(pid))
    );

    if (!buttons.length) return;

    // Is product wishlisted (theme sets all as active)?
    var productActive = buttons.some(isThemeActive);

    var map = readMap();

    if (!productActive) {
      // Product not in wishlist anymore -> clear selected variant and reset UI
      if (map[pid]) {
        delete map[pid];
        writeMap(map);
      }
      buttons.forEach(function (b) { setUI(b, false); });
      return;
    }

    // Product is wishlisted -> choose ONE variant to visually show as active
    var desiredVid = pending[pid] || map[pid] || '';

    // If desired variant not present on page, fallback to first visible button
    if (desiredVid && !buttons.some(function (b) { return getVid(b) === desiredVid; })) {
      desiredVid = '';
    }
    if (!desiredVid) desiredVid = getVid(buttons[0]) || '';

    // Persist choice
    map[pid] = desiredVid;
    writeMap(map);

    // Apply UI: only desired variant is active
    buttons.forEach(function (b) {
      setUI(b, getVid(b) === desiredVid);
    });
  }

  function syncAll() {
    // Collect all product ids present on page
    var els = Array.prototype.slice.call(document.querySelectorAll('hdt-wishlist'));
    var seen = {};
    els.forEach(function (el) {
      var pid = getPid(el);
      if (pid) seen[pid] = true;
    });

    Object.keys(seen).forEach(syncPid);
  }

  // Do NOT block theme click. Let Ecomus add/remove wishlist normally.
  document.addEventListener('click', function (e) {
    var el = findWishlistEl(e);
    if (!el) return;

    var pid = getPid(el);
    var vid = getVid(el);

    if (!pid) return;

    if (vid) pending[pid] = vid;

    // Theme usually toggles state asynchronously; resync after it finishes
    setTimeout(function () { syncPid(pid); }, 60);
    setTimeout(function () { syncPid(pid); }, 220);
    setTimeout(function () { syncPid(pid); }, 900);
  }, true);

  document.addEventListener('DOMContentLoaded', function () {
    syncAll();
    setTimeout(syncAll, 250);
    setTimeout(syncAll, 800);
  });

  document.addEventListener('shopify:section:load', function () {
    syncAll();
    setTimeout(syncAll, 250);
  });

  window.addEventListener('pageshow', function () {
    syncAll();
    setTimeout(syncAll, 250);
  });
})();